import { Input } from "@trackman/web-shared-components";

type Props = {
  lessonContent: string;
  handleLessonContent: (lessonContent: string | undefined) => void;
};

export const ChapterTestField = ({ lessonContent, handleLessonContent }: Props) => {
  return (
    <Input
      label='Area9 Entrypoint'
      value={lessonContent}
      required
      onChange={(e) => handleLessonContent(e.currentTarget.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    />
  );
};